import { Link } from "react-router-dom";

export function Footer() {
  return (
    <footer className="border-t hairline mt-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <div className="font-display text-3xl font-bold">THE CHEAPER WAY</div>
            <p className="font-serif text-xl text-stone-400 mt-3 max-w-md leading-snug">
              Before you buy it, find a better way to get it. A consumer intelligence desk for
              everyday life — spend intentionally, cut waste, keep what actually makes life better.
            </p>
          </div>
          <div>
            <div className="eyebrow mb-4">THE PRODUCT</div>
            <ul className="space-y-2 font-label text-xs text-stone-400">
              <li><Link to="/life/secondhand" className="link-hover">Secondhand Shopping</Link></li>
              <li><Link to="/find" className="link-hover">Find the Cheaper Way</Link></li>
              <li><Link to="/audit" className="link-hover">Run an Audit</Link></li>
              <li><Link to="/opportunities" className="link-hover">Opportunities</Link></li>
              <li><Link to="/buy-when" className="link-hover">Buy When</Link></li>
              <li><Link to="/benefits" className="link-hover">Benefit Finder</Link></li>
            </ul>
          </div>
          <div>
            <div className="eyebrow mb-4">ACCOUNT</div>
            <ul className="space-y-2 font-label text-xs text-stone-400">
              <li><Link to="/notes" className="link-hover">Notes / Saved</Link></li>
              <li><Link to="/pro" className="link-hover">The Cheaper Way Pro</Link></li>
              <li><Link to="/login" className="link-hover">Log in</Link></li>
            </ul>
          </div>
        </div>
        <div className="mt-12 pt-6 border-t hairline flex flex-col md:flex-row justify-between gap-3">
          <p className="font-label text-[10px] tracking-widest text-stone-500">© {new Date().getFullYear()} THE CHEAPER WAY · NO BANK LOGIN · NO JUDGMENT</p>
          <p className="font-label text-[10px] tracking-widest text-stone-500 max-w-lg">
            We may earn a commission on some links. It does not affect our recommendations. Potential savings, not guaranteed.
          </p>
        </div>
      </div>
    </footer>
  );
}
